import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function BarCelona() {
  const ProjectBG = require("../../../../assets/videos/bar-celona/poster.png");
  const T1 = require("../../../../assets/videos/bar-celona/poster.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Café Bar Celona AR menu — WebAR for dining"
      lead={
        <p>
          A WebAR experience that lets guests scan QR codes on the menu to
          preview dishes and products in 3D—no app install required—so ordering
          feels tangible and fun.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/Bar+Celona+WebAR.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Discover the menu in 3D</WorkSectionHeading>
          <p>
            Guests scan printed QR codes with a phone or tablet to unlock
            interactive 3D previews of ice cream and dishes—built from
            meticulously scanned models with accurate materials and color.
          </p>
          <p>
            The experience runs in the browser for low friction and broad
            accessibility.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Available exclusively at Café Bar Celona locations—where technology
          meets gastronomy through quick scans and immersive previews.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Bar Celona AR Menu" },
          { label: "Period", value: "02.2023 - 03.2023" },
          { label: "Client", value: "Cafe Bar Celona" },
          { label: "Engine & Tools", value: "ModelViewer" },
          { label: "Platform", value: "Web" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "WebAR" },
        ]}
      />
    </WorkProjectShell>
  );
}
